export default __webpack_public_path__ + "static/media/main_new_bg.078900e9.jpg";